import { BrowserRouter, Routes, Route } from "react-router-dom";
import Body from "./components/body";
import ContactSection from "./components/ContactSection/ContactSection";
import TermsOfUse from "./components/LegalSection/TermsOfUse";
import Blogs from "./components/Resources/Blogs/Blogs";
import BlogDetail from "./components/Resources/Blogs/BlogDetail";
import PressRelease from "./components/Resources/PressRelease";
import FAQPage from "./components/Resources/FAQPage";
import PrivacyPolicy from "./components/LegalSection/PrivacyPolicy";
import CookiePolicy from "./components/LegalSection/CookiePolicy";
import DetailSection from "./components/DetailSection/DetailSection";
import Home from "./components/RoutePages/home";
import Offers from "./components/RoutePages/Offers";
import DataCenters from "./components/RoutePages/DataCenters";
import NotFound from "./components/RoutePages/NotFound";
import ScrollToTop from "./components/common/ScrollToTop";
import ChatSection from "./components/ChatSection/ChatSection";
import CookieConsentBanner from "./components/common/CookieConsentBanner";
import DataCenterCity from "./components/DataCenterCity/DataCenterCity";
import ColocationCalculator from "./components/Tools/ColocationCalculator";

const AppRoutes = () => {
  return (
    <BrowserRouter basename="/">
      <ScrollToTop />
      <ChatSection />
      <CookieConsentBanner />
      <Routes>
        <Route path="/" element={<Body />}>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<ContactSection />} />
          <Route path="/offers" element={<Offers />} />
          <Route path="/legal/terms" element={<TermsOfUse />}></Route>
          <Route path="/legal/privacy" element={<PrivacyPolicy />}></Route>
          <Route path="/legal/cookies" element={<CookiePolicy />}></Route>
          <Route path="/details/:pageId" element={<DetailSection />}></Route>
          <Route path="/company/:pageId" element={<DetailSection />}></Route>
          <Route path="/services/:pageId" element={<DetailSection />}></Route>
          <Route path="/resources/blogs" element={<Blogs />}></Route>
          <Route path="/resources/blogs/:id" element={<BlogDetail />}></Route>
          <Route path="/resources/faq" element={<FAQPage />}></Route>
          <Route
            path="/resources/press-release"
            element={<PressRelease />}
          ></Route>
          <Route
            path="/colocation-cost-calculator"
            element={<ColocationCalculator />}
          />
          <Route path="/data-centers" element={<DataCenters />} />
          <Route path="/data-centers/:city" element={<DataCenterCity />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
